import * as React from 'react';
import { FolderType, ReportCategory } from 'app/area/case-report/case-listing/types';
import { ReportId } from 'app/area/saved-reports/constants';

export const withSavedCompanyReport = (WrappedComponent: React.ComponentType) => {

  return (props: any) => {
    return <WrappedComponent {...props} reportCategories={[ReportCategory.SpecialReport]} folderType={FolderType.SpecialReport} 
      selectedReport={ReportId.CompanyReport}/>;    
  };
};
